/**
 * StatisticGroup
 */
import { useEffect, useState } from "react";
import { handleHttp } from "@/components/Menu/ProCard/utils/valueConfig";
import { DEFAULT_DATA } from "@/config";

import Statistic from "../Statistic";
import "./index.less";

export interface StatisticGroupProps {
  items?: any[];
  title?: string;
  value?: string;
  valueConfig?: any;
  titleStyle?: object;
  wrapStyle?: object;
  listStyle?: object;
  updateKey?: number | undefined;
}

const StatisticClassPrefix = "iot-component-statistic-group";

const StatisticGroup = (props: StatisticGroupProps) => {
  const {
    items = [],
    title = "",
    value = DEFAULT_DATA,
    valueConfig = null,
    wrapStyle = {},
    listStyle = {},
    titleStyle = {},
    updateKey,
  } = props;

  const [result, setResult] = useState(value);

  const updateData = () => {
    if (valueConfig) {
      if (
        valueConfig.type === "http" &&
        (result === DEFAULT_DATA || updateKey)
      ) {
        handleHttp(valueConfig, (resultIn: any) => {
          setResult(resultIn);
        });
      }
    }
  };

  useEffect(() => {
    updateData();
  }, [updateKey]);

  return (
    <div className={`${StatisticClassPrefix}`} style={wrapStyle}>
      {title && (
        <span className={`${StatisticClassPrefix}-title`} style={titleStyle}>
          {title}
        </span>
      )}
      <div className={`${StatisticClassPrefix}-list`} style={listStyle}>
        {items &&
          items.map((item, key) => {
            return (
              <Statistic
                key={item.valueKey || key}
                {...item}
                value={result[item.valueKey]}
                updateKey={updateKey}
              />
            );
          })}
      </div>
    </div>
  );
};

export default StatisticGroup;
